import queryString from 'query-string';
import { Base64 } from 'js-base64';
import axios from 'axios';
import * as log from 'loglevel';

/**
 * Checks if a string is 'true' or '1' and returns
 * true then, false otherwise (true boolean).
 */
function boolStringToBool(boolString) {
  return boolString === 'true' || boolString === '1';
}

export default class KdQueryParser {
  constructor(store) {
    this.store = store;
  }

  /* eslint-disable class-methods-use-this */
  /**
   * Expected object:
   *   {
   *     print: "true|false",
   *     card: "976hdjd92" (base64 encoded stringified card object)
   *   }
   * Encode the card-data like this:
   *   const encoded = Base64.encodeURI(JSON.stringify(cardData));
   * @param {String} query - pass window.location.search, e.g.
   *   "?print=true&card=12jg47"
   */
  async parse(query) {
    log.debug('URL Params: ', query);
    const parsed = queryString.parse(query);
    log.debug('URL Params (parsed using querystring): ', parsed);
    if (parsed.cardUrl) {
      try {
        log.debug('Parsed card (using querystring): ', parsed.card);
        // the card contains the
        const cardConfigUrl = Base64.decode(parsed.cardUrl);
        const cardConfig = await axios.get(process.env.VUE_APP_IMAGE_SERVER + cardConfigUrl)
          .catch((err) => {
            log.error(err);
            alert('Die Grußkarte konnte nicht vom Server geladen werden. Wir bitten um Entschuldigung.');
          });

        // parsed.card = JSON.parse(Base64.decode(parsed.card));
        parsed.card = cardConfig.data;
        log.debug('Base64 parsed card (using Base64.decode): ', parsed.card);
      } catch (e) {
        log.error('There was a problem loading the card from URI', e);
      }
    }
    // booleans cannot be transmitted via URI,
    // so we need to parse manually
    if (typeof parsed.print === 'string') {
      parsed.print = boolStringToBool(parsed.print);
    }
    if (typeof parsed.screenshot === 'string') {
      parsed.screenshot = boolStringToBool(parsed.screenshot);
    }
    return parsed;
  }
}
